import * as Actions from '../actions';
import {MetaAction} from '../actions/types';
import {invalidAction, ErrorAction} from '../actions/Error';
import {PREFIX} from './constants';
import {Indexable} from './merge';
const MANDATORY_ACTION_PROPS = ['group', 'type', 'version'];

export function isAppBridgeAction(action: any): action is MetaAction {
  return (
    action instanceof Object &&
    action.hasOwnProperty('type') &&
    action.type.toString().startsWith(PREFIX)
  );
}

export function isFromApp(action: any) {
  if (typeof action !== 'object' || typeof action.source !== 'object') {
    return false;
  }

  return typeof action.source.apiKey === 'string';
}

export function isAppMessage(event: any) {
  if (typeof event !== 'object' || !event.data || typeof event.data !== 'object') {
    return false;
  }

  const {data} = event;

  return data.hasOwnProperty('type') && (data.type === 'getState' || data.type === 'dispatch');
}

export function validatedActionPayload<A extends MetaAction>(
  action: A,
  origin?: string,
): ErrorAction | A {
  switch (action.group) {
    case Actions.Group.Button:
      return Actions.Button.validationError(action) || action;

    case Actions.Group.ButtonGroup:
      return Actions.ButtonGroup.validationError(action) || action;

    case Actions.Group.Cart:
      return Actions.Cart.validationError(action) || action;

    case Actions.Group.Toast:
      return Actions.Toast.validationError(action) || action;

    case Actions.Group.Modal:
      return Actions.Modal.validationError(action, origin) || action;

    case Actions.Group.TitleBar:
      return Actions.TitleBar.validationError(action) || action;

    case Actions.Group.Navigation:
      return Actions.Navigation.validationError(action) || action;

    case Actions.Group.Error:
      return action;

    case Actions.Group.Print:
      return Actions.Print.validationError(action) || action;

    case Actions.Group.Loading:
      return Actions.Loading.validationError(action) || action;

    case Actions.Group.ResourcePicker:
      return Actions.ResourcePicker.validationError(action) || action;
    default:
      return invalidAction(action, 'Unknown or unsupported action group');
  }
}

export function validatedAction<A extends Indexable>(action: A, origin?: string): ErrorAction | A {
  if (!isAppBridgeAction(action)) {
    return action;
  }

  for (const prop of MANDATORY_ACTION_PROPS) {
    if (!action.hasOwnProperty(prop) || typeof action[prop] !== 'string') {
      return invalidAction(action, `Missing or invalid ${prop}`);
    }
  }

  return validatedActionPayload(action, origin);
}



// WEBPACK FOOTER //
// ./src/actions/validator.ts